import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { toast } from "sonner";
import { LockKeyhole } from "lucide-react";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("guango_admin_token", res.data.token);
      localStorage.setItem("guango_admin_email", res.data.email);
      toast.success("Adentro!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login fallido.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="max-w-xl mx-auto px-5 sm:px-8 pt-16 pb-24">
        <div className="bg-white border-4 border-[#1a1a1a] rounded-3xl shadow-hard-lg p-8 sm:p-12 pop-in" data-testid="admin-login-card">
          <div className="w-14 h-14 rounded-2xl border-4 border-[#1a1a1a] bg-[#22c55e] flex items-center justify-center mb-6 shadow-hard-sm">
            <LockKeyhole className="w-6 h-6" strokeWidth={3} />
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-2">admin.</h1>
          <p className="font-mono text-sm text-[#4a4a4a] mb-8">Solo para Guango.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="font-mono text-xs uppercase tracking-[0.25em] font-bold mb-2 block">email</label>
              <input
                data-testid="admin-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#f7f5f0] border-4 border-[#1a1a1a] rounded-xl px-4 py-3 font-mono text-base focus:bg-white"
                placeholder="admin@guango.co"
              />
            </div>
            <div>
              <label className="font-mono text-xs uppercase tracking-[0.25em] font-bold mb-2 block">password</label>
              <input
                data-testid="admin-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#f7f5f0] border-4 border-[#1a1a1a] rounded-xl px-4 py-3 font-mono text-base focus:bg-white"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="press w-full bg-[#1a1a1a] text-white border-4 border-[#1a1a1a] rounded-xl px-6 py-4 font-display font-black text-xl shadow-hard-md disabled:opacity-60"
            >
              {loading ? "Verificando..." : "entrar →"}
            </button>
          </form>
        </div>
      </section>
    </Layout>
  );
};

export default AdminLogin;
